import truncateByChars from 'zignal-landscape/lib/utils/truncateByChars';
import {
  STORY_BODY_DEFAULT_MAX,
  STORY_TITLE_DEFAULT_MAX,
  STORY_TWITTER_MAX
} from 'zignal-landscape/lib/Story';

if (typeof window !== 'undefined') {
  window.Helper = window.Helper || {};
  window.Helper.truncateByChars = truncateByChars;
  window.Helper.STORY_BODY_MAX_CHARS = STORY_BODY_DEFAULT_MAX;
  window.Helper.STORY_TITLE_MAX_CHARS = STORY_TITLE_DEFAULT_MAX;
  window.Helper.STORY_TWITTER_MAX_CHARS = STORY_TWITTER_MAX;
}

export default truncateByChars;
